import React from 'react'
import { AutoComplete } from '@softura/customcomponent'
import './Autocomplete.scss'

interface IProps {
    data?:any,
    placeholder?:string,
    className?:string,
    suggestions?:any,
    onSuggestionSelected?:any
    inputProps?:any
}
const AutoCompleteContainer = ({data, placeholder, className,suggestions, inputProps, onSuggestionSelected }:IProps) => {
  return (<>
    <AutoComplete
        data={data}
        placeholder={placeholder}
        className={className}
        suggestions={suggestions}
        onSuggestionSelected={onSuggestionSelected}
        inputProps={inputProps}
     data-attribute="index_Default_Autocomplete" />
  </>)
}

export default AutoCompleteContainer
